import type {TeamGrid} from './grid';
import {FullTeamGrid} from './grid/full';
import type {Team} from './team';

export interface TeamMemberData {
	id: number;
	order: number;
	url: string;
	image?: string;
	first: string;
	last: string;
	credentials: string;
	title: string;
	teams: TeamMemberSortData[];
}

interface TeamMemberSortData {
	id: number;
	order?: number;
}

interface TeamMemberElements {
	item: HTMLLIElement;
	link: HTMLAnchorElement;
	image: HTMLElement;
	name: HTMLHeadingElement;
	title: HTMLDivElement;
}

export class TeamMember {
	private readonly teams?: Team[];
	private readonly elements: TeamMemberElements = {
		item: document.createElement('li'),
		link: document.createElement('a'),
		image: document.createElement('figure'),
		name: document.createElement('h4'),
		title: document.createElement('div')
	};
	public readonly sortableName: string;

	constructor(private readonly grid: TeamGrid, private readonly data: TeamMemberData) {
		this.sortableName = `${this.data.last}, ${this.data.first}`;

		if (this.grid instanceof FullTeamGrid && this.data.teams?.length) {
			this.teams = this.data.teams.map(({id}) => (this.grid as FullTeamGrid).getTeam('id', id)).filter((team) => team) as Team[];
			this.teams.push(this.grid.getTeam('id', 0) as Team);
			for (const team of this.teams) team.members.push(this);
		}

		this.elements.item.append(this.elements.link);
		this.elements.link.append(this.elements.image, this.elements.name, this.elements.title);
		this.elements.link.href = this.data.url;
		this.elements.name.innerText = `${this.data.first} ${this.data.last}`;
		if (this.data.credentials) this.elements.name.innerText += `, ${this.data.credentials}`;
		this.elements.title.innerText = this.data.title;
		if (this.data.image) this.elements.image.style.backgroundImage = `url("${this.data.image}")`;
		this.supR('name');
		this.supR('title');
	}

	private supR(elementId: keyof TeamMemberElements): void {
		this.elements[elementId].innerHTML = this.elements[elementId].innerHTML.replace(/®/g, '<sup>®</sup>');
	}

	public render(): void {
		this.grid.elements.grid.append(this.elements.item);
	}

	public getOrder(team?: Team): number {
		if (!team?.id) return typeof this.data.order === 'number' ? this.data.order : 100;
		const orderData = this.data.teams.find((teamData) => teamData.id === team.id);
		if (orderData && typeof orderData.order === 'number') return orderData.order;
		return 100;
	}
}
